import { createContext } from "react";

const DiscountCodesContext = createContext(null);
export default DiscountCodesContext;
